import LoginForm from "../login/LoginForm";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
    const { t } = useTranslation();
    const nav = useNavigate();

  return (
    <div className="text-center">
       <h5 className="subtitle text-left mb-2">{t('login.title')}</h5>
          <LoginForm />
          <div className="d-flex flex-column align-items-center mt-2">
              <a href="#" onClick={() => { nav(`/forgot-password`) }}>{t('login.forgotPassword')}</a>    
              <a href="#" className="mt-2" onClick={() => { nav(`/privacy-policy`) }}>{t('privacyPolicy.privacyPolicy')}</a>    
              {/*<a href="#" className="mt-2" onClick={() => { nav(`/version-history`) }}>{t('versionHistory.versionHistory')}</a>*/}
          </div>
    </div>
  );
};

export default LoginPage;